export class SKUDTO {

    constructor(
        public id: string,
        public price: number | null,
        public onSale: boolean
    ) { }
}
